(() => {
  // Play looping videos only while on screen; keep the poster when reduced motion is requested.
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => (e.isIntersecting ? e.target.play().catch(() => {}) : e.target.pause())),
      { threshold: 0.35 }
    );
    document.querySelectorAll('video.dp-loop').forEach((v) => io.observe(v));
  }

  // Catalogue tabs.
  document.querySelectorAll('.dp-shop').forEach((shop) => {
    const tabs = shop.querySelectorAll('[role="tab"]');
    tabs.forEach((t) =>
      t.addEventListener('click', () => {
        tabs.forEach((x) => x.setAttribute('aria-selected', x === t));
        shop.querySelectorAll('[role="tabpanel"]').forEach((p) => (p.hidden = p.id !== t.getAttribute('aria-controls')));
      })
    );
  });
})();
